import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    compOffData: {},
    serverResponseStatus: {
        apiCalled: false,
        message: '',
        hasError: false
    },
    loader: false,
    confirmationModal: { show: false, statusId: 0, titlle: "" },
    approveId: 0,
    rejectId: 0,
}

export const compOffView = createSlice({
    name: 'compOffView',
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.loader = action.payload;
        },
        apiResponse: (state, action) => {
            state.serverResponseStatus = action.payload;
        },
        setCompOffData: (state, action) => {
            state.compOffData = action.payload;
        },
        setConfirmationModal: (state, action) => {
            state.confirmationModal = {...action.payload};
        },
        closeConfirmationModal:(state,action)=>{
            state.confirmationModal = { show: false, statusId: 0, titlle: "" }
        },
        setStatusId: (state,action)=>{
            const {approveId,rejectId} = action.payload;
            state.approveId = approveId;
            state.rejectId = rejectId;
        },
        resetState: () => initialState,
    }
})

export const { setConfirmationModal, setCompOffData, setLoader, setStatusId,apiResponse,closeConfirmationModal,resetState } = compOffView.actions;
export default compOffView.reducer;